import ServiceCreate from './ServiceCreate';

export default ServiceCreate;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServiceCreate/index.js